import type { PlaceStatus, ReturnIntent } from './types';

export const STATUS_LABELS: Record<PlaceStatus, string> = {
  want: 'Хочу посетить',
  visited: 'Был',
};

export const RETURN_INTENT_LABELS: Record<Exclude<ReturnIntent, null>, string> = {
  yes: 'Зайду ещё',
  no: 'Больше не приду',
  unsure: 'Пока не решил',
};

export const INITIAL_TAGS = ['поработать', 'с девушкой', 'с друзьями', 'погулять'] as const;
